import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav/Nav';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import TheEiffel from './pages/TheEiffel';
import EiffelArticle from './pages/EiffelArticle';
import Gallery from './pages/Gallery';
import Baltsazar from './pages/Baltsazar';
import './theme/theme.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/the-eiffel" element={<TheEiffel />} />
        <Route path="/the-eiffel/:slug" element={<EiffelArticle />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/baltsazar" element={<Baltsazar />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
